import React, { Component } from 'react';
import { Button } from '@kambria/kambria-lego';


class NotFound extends Component {

  home = () => {
    this.props.history.push('/');
  }

  render() {
    return (
      <main className="main token">
        <div className="tab-content">
          <div className="container">
            <h3 className="definition">OOPS, SORRY WE CAN'T FIND THAT PAGE!</h3>
            <p className="description d-block w-100 text-left">Either something went wrong or the page doesn't exist anymore.</p>
            <Button type="primary" size="sm" onClick={this.home}>Back to Home</Button>
          </div>
        </div>
      </main>
    );
  }
}

export default NotFound;